export class MqttRtData {
  constructor(
    public idModulo: number,
    public variable: string,
    public valor: number,
    public alarma: number,
    public timeout: number,
    public valorMin: number,
    public valorMax: number,
    public valorPromedio: number,
    public valorFum: string,
    public alarmaFum: string,
    public resetEstadisticaFum: string,
  ) { }
}

export class MqttAlarmConfig {
  constructor(
    public requestMode: string = '',
    public idAlarma: number = 0,
    public habilitado: boolean = true,
    public nombreAlarma: string = '',
    public descripcion: string = '',
    public limiteMinMin: number = 0,
    public limiteMinMax: number = 0,
    public limiteMaxMin: number = 0,
    public limiteMaxMax: number = 0,
    public habAlarma: boolean = true,
    public habMapaWa: boolean = false,
    public wsCfgId: number = 0,
    public habAlertaWaMinimo: boolean = false,
    public formatoMensajeMinimoWa: string = '',
    public habAlertaWaNormal: boolean = false,
    public formatoMensajeNormalWa: string = '',
    public habAlertaWaMaximo: boolean = false,
    public formatoMensajeMaximoWa: string = '',
    public tiempoAlerta: number = 0,
    public formatoMensajeTimeoutOn: string='',
    public formatoMensajeTimeoutOff: string='',
    public habAlertaTimeoutOff: boolean=false,
    public habAlertaTimeoutOn: boolean=false,
    public wsCfgIdTimeout: number=0,
    public eliminado: boolean = false

  ) { }
}

export class MqttApplicationConfig {
  constructor(
    public idAplicacion: number = 0,
    public descripcion: string = '',
    public habilitado: boolean = true
  ) { }
}

export class MqttGeneralInfo {
  constructor(
    public deviceId: number,
    public idAplicacion: number,
    public idModulo: number,
    public variable: string,
    public referencia: string,
    public descripcion: string,
    public valor: number,
    public unidad: string,
    public valorFum: string,
    public alarma: number,
    public alarmaFum: string,
    public timeout: boolean,
    public valorMin: number,
    public valorMax: number,
    public valorPromedio: number,
    public resetEstadisticaFum: string,
    public barrio: string,
    public direccion: string,
    public latitud: number,
    public longitud: number,
    public habTrend: boolean,
    public habAlarma: boolean
  ) { }
}

export class MqttModuloConfig {
  constructor(
    public idModulo: number = 0,
    public deviceId: number = 2,
    public habilitado: boolean = true,
    public topic: string = '',
    public parser: string = '',
    public descripcion: string = '',
    public barrio: string = '',
    public direccion: string = '',
    public longitud: number = 0,
    public latitud: number = 0,
    public requestOk: boolean = true,
    public failureCause: string = 'OK',
    public eliminado: boolean = false,
    public requestMode: string = ''
  ) { }
}

export class MqttVariableConfig {
  constructor(
    public requestMode: string='',
    public idModulo: number=0,
    public variableSistema: string='',
    public idAplicacion: number=0,
    public habilitado: boolean=true,
    public variableTopic: string='',
    public variableUser: string='',
    public descripcion: string='',
    public unidad: string='',
    public habTrend: boolean=false,
    public trendStep: number=300,
    public idAlarma: number=0,
    public habAlarma: boolean=false,
    public habEscala: boolean=false,
    public multiplicador: number=1,
    public offset: number=0,
    public rtStep: number=300,
    public habPromedio: boolean=false,
    public promStep: number=300,
    public useFullMode: boolean=false,
    public eliminado: boolean = false,
    public nombreAlarma: string = '',
    public descripcionModulo: string = ''
  ) { }
}

export class MqttParserData {
  constructor(
    public valor: string,
    public descripcion: string
  ) { }
}


  export enum MqttApps {
    MEDICION_PRESION_AGUA = 1
  }
